import { useEffect } from 'react';

export const useDocumentDropGuard = () => {
  useEffect(() => {
    const preventDefaultDragEvent = (event: DragEvent) => event.preventDefault();

    document.addEventListener('dragover', preventDefaultDragEvent);
    document.addEventListener('drop', preventDefaultDragEvent);

    return () => {
      document.removeEventListener('dragover', preventDefaultDragEvent);
      document.removeEventListener('drop', preventDefaultDragEvent);
    };
  }, []);
};
